<div class="question__footer">
  <div class="question__footer-toggle">
    @if (questionTypeConfig[questionType]; as config) {
      @if (config.noneOptionFlag) {
        <empathy-toggle [label]="'None option'" [control]="question.get('noneOptionInd')! | toFormControl" [disabled]="disabled" />
      }

      @if (config.otherOptionFlag) {
        <empathy-toggle [label]="'Other option'" [control]="question.get('otherOptionInd')! | toFormControl" [disabled]="disabled" />
      }

      @if (config.randomizeFlag) {
        <empathy-toggle [label]="'Randomize options'" [control]="question.get('randomizeOptionsInd')! | toFormControl" [disabled]="disabled" />
      }

      @if (config.mandatoryFlag) {
        <empathy-toggle [label]="'Make required'" [control]="question.get('mandatoryInd')! | toFormControl" [disabled]="disabled" />
      }
    }
  </div>
</div>
